import { IMPACT } from "../../lib/data";
import { STAGGER_MS } from "../../lib/constants";

export const Impact = () => {
  return (
    <section
      id="impact"
      data-testid="impact-section"
      className="hairline-b border-b bg-[var(--ink)] text-[var(--paper)]"
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-28">
        <div className="grid grid-cols-12 gap-6 mb-12 md:mb-16">
          <div className="col-span-12 md:col-span-6">
            <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
              04 — Business Impact
            </div>
            <h2 className="text-4xl md:text-7xl font-bold tracking-tight leading-[0.92]">
              Strategy is<br />
              <span className="opacity-50">measured at the</span><br />
              bottom line.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9 self-end">
            <p className="text-base md:text-lg leading-relaxed opacity-70 max-w-prose">
              Every campaign ladders back to a business KPI. These are the
              numbers that mattered most.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 border-l border-t border-white/15">
          {IMPACT.map((stat, i) => (
            <div
              key={stat.label}
              data-testid={`impact-${i}`}
              className="border-r border-b border-white/15 p-6 md:p-10 reveal"
              style={{ transitionDelay: `${i * STAGGER_MS}ms` }}
            >
              <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-8 md:mb-14">
                {stat.label}
              </div>
              <div className="font-mono text-5xl md:text-7xl font-medium tracking-tighter leading-none">
                {stat.value}
              </div>
              <div className="mt-4 md:mt-6 text-xs md:text-sm opacity-70">
                {stat.note}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
